var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Header, Tab } from "semantic-ui-react";
import AmplifierLabelTable from "./AmplifierLabelTable";
import AmplifierScaleTracking from "./AmplifierScaleTracking";
import BufferTracking from "./BufferTracking";
var TrackingPage = /** @class */ (function (_super) {
    __extends(TrackingPage, _super);
    function TrackingPage(props) {
        return _super.call(this, props) || this;
    }
    TrackingPage.prototype.render = function () {
        var panes = [
            {
                menuItem: 'Oustanding orders',
                render: function () { return React.createElement(Tab.Pane, { key: 'amplifier-outstanding-orders' },
                    React.createElement(AmplifierLabelTable, { urlPath: '/admin/tracking/amplifiers/outstanding-orders' })); }
            },
            {
                menuItem: 'Complete orders',
                render: function () { return React.createElement(Tab.Pane, { key: 'amplifier-complete-orders' },
                    React.createElement(AmplifierLabelTable, { urlPath: '/admin/tracking/amplifiers/complete-orders' })); }
            },
            {
                menuItem: 'Amplifier scale',
                render: function () { return React.createElement(Tab.Pane, { key: 'amplifier-aliquot-scales' },
                    React.createElement(AmplifierScaleTracking, null)); }
            },
            {
                menuItem: 'Buffers',
                render: function () { return React.createElement(Tab.Pane, { key: 'buffers' },
                    React.createElement(BufferTracking, null)); }
            }
        ];
        return React.createElement(React.Fragment, null,
            React.createElement("div", { id: "non-header-portion" },
                React.createElement(Header, null, "Tracking"),
                React.createElement(Tab, { panes: panes })));
    };
    return TrackingPage;
}(React.PureComponent));
export default TrackingPage;
//# sourceMappingURL=TrackingPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/TrackingPage.js
// module id = 1312
// module chunks = 0